import "./app.css";
import "../pollen.css";
import App from "./App.svelte";
import { setup } from "./lib/helpers/setup";

setup();

const app = new App({
  target: document.getElementById("app")!
});

export default app;
